module.exports = __webpack_public_path__ + "img/img1.2ef6abe4.png";